import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import ReactTooltip from 'react-tooltip';

class ReportTableRow extends Component {
  // ----------------------
  // Computed
  // ----------------------

  get canAdd() {
    return (this.props.report.status === 'scheduled')
      && this.props.userContext.hasScope(this.props.report.signFlow[this.props.report.type].submit.roles);
  }

  get canDelete() {
    if (this.props.report.getIsSubmitted()) {
      return false;
    }
    return !this.props.report.getHasScheduledAction()
      ? this.canEdit
      : this.props.userContext.hasScope(['ftoc', 'sup']);
  }

  get canEdit() {
    return (this.props.report.status === 'draft' || this.props.report.status === 'rejected')
      && (
        (this.props.report.author && this.props.report.author.authorGuid === this.props.userContext.userGuid) ||
        (this.props.report.type === 'orientation' && this.props.userContext.hasScope(['oit'])) ||
        (this.props.phase && this.props.phase.fto && this.props.phase.fto.ftoGuid === this.props.userContext.userGuid) ||
        this.props.userContext.hasScope(['ftoc', 'sup'])
        //todo improve this  with sign flow
      );
  }

  get canFtocView() {
    if(this.props.disableView) {
      return false
    }
    return (this.props.report.status === 'draft' || this.props.report.status === 'rejected' || this.props.report.status === 'scheduled')
      && !this.canEdit
      && this.props.userContext.hasScope(['ftoc', 'sup']);
  }

  get canRewrite() {
    return false;
    return this.props.report.status !== 'draft'
      && this.props.userContext.hasScope(['ftoc', 'sup'])
  }

  get canView() {
    if(this.props.disableView) {
      return false;
    }
    if (this.props.report.getIsCompleted()) {
      return true;
    }
    if (!this.props.report.getIsSubmitted()) {
      return false;
    }
    return !this.props.report.getCanAcknowledge(this.props.userContext.scope)
      && !this.props.report.getCanApprove(this.props.userContext.scope)
      && !this.props.report.getCanApproveTwo(this.props.userContext.scope)
      && !this.props.report.getCanApproveThree(this.props.userContext.scope)
      && !this.props.report.getCanApproveFour(this.props.userContext.scope)
      && !this.props.report.getCanApproveFive(this.props.userContext.scope)
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return !this.props.report.getIsSubmitted() ? (
      <tr>
        <td style={{whiteSpace: 'nowrap'}}>{this.props.report.date}</td>
        <td>{this.props.report.formName}</td>
        <td>
          {this.props.report.status === 'draft' &&
            <span className="badge badge-secondary">
              Draft
            </span>
          }
          {this.props.report.status === 'cancelled' &&
            <span className="badge badge-disabled">
              Cancelled
            </span>
          }
          {this.props.report.status === 'rejected' &&
          <span className="badge badge-danger">
              Rejected
            </span>
          }
          {this.props.report.status === 'scheduled' &&
          <span className="badge badge-primary">
              Scheduled
            </span>
          }
          {this.props.report.status === 'acknowledged' &&
          <span className="badge badge-secondary">
           Acknowledged
          </span>}
          {this.props.report.status === 'submitted' &&
          <span className="badge badge-success">
           Submitted
          </span>}
        </td>
        <td>
          {this.props.report.getIsDueToday() &&
          <span className="badge badge-info">Submit Today</span>
          }
          {this.props.report.getIsDueNow() &&
          <span className="badge badge-warning">Submit Now</span>
          }
          {this.props.report.getIsLate() &&
          <span className="badge badge-danger">Late Submit</span>
          }
        </td>
        <td>
          {this.props.report.author &&
          this.props.report.getFullNameFor('author')
          }
        </td>
        <td className="td-actions">
          <ReactTooltip place="top" className="customTheme" effect="solid"/>
          {this.canAdd &&
          <button
            className="button default small"
            data-tip="Add report"
            onClick={() => this.props.onAddScheduledReport(this.props.report.guid, this.props.report.type)}
          >
              <i className="fa fa-plus" />
            </button>
          }
          {this.canEdit &&
          <button
            className="button default small"
            data-tip="Edit report"
            onClick={() => this.props.onEditReport(this.props.report.guid)}
          >
            <i className="fa fa-edit"/>
          </button>
          }
          {this.canFtocView &&
          <button
            className="button default small"
            data-tip="View report"
            onClick={() => this.props.onViewReport(this.props.report.guid)}
          >
            <i className="fa fa-list"/>
          </button>
          }
          {this.canDelete &&
          <Fragment>
            {this.props.report.getHasScheduledAction() ? (
              <button
                className="button default small"
                data-tip="Delete"
                onClick={() => this.props.onDeleteScheduledReport(this.props.report.guid)}
              >
                <i className="fa fa-trash"/>
              </button>
              ) : (
                <button
                  className="button default small"
                  data-tip="Delete"
                  onClick={() => this.props.onDeleteDraftReport(this.props.report.guid)}
                >
                  <i className="fa fa-trash" />
                </button>
              )}
            </Fragment>
          }
        </td>
      </tr>
    ) : (
      <tr onClick={() => this.props.onViewReport(this.props.report.guid)}>
        <td>{this.props.report.date}</td>
        <td>{this.props.report.formName}</td>
        <td>
          {this.props.report.getIsAckDueToday() &&
            <span>Acknowledge Today</span>
          }
          {this.props.report.getIsAckDueNow() &&
            <span className="badge badge-warning">Acknowledge Now</span>
          }
          {this.props.report.getIsLateAck() &&
            <span className="badge badge-danger">Late Acknowledgement</span>
          }
          {this.props.report.getIsApprovalDueNow() &&
          <span className="badge badge-warning">Approve 1 Now</span>
          }
          {this.props.report.getIsLateApproval() &&
          <span className="badge badge-danger">Late Approval 1</span>
          }
          {this.props.report.getIsApproveTwoDueNow() &&
          <span className="badge badge-warning">Approve 2 Now</span>
          }
          {this.props.report.getIsApproveTwoIsLate() &&
          <span className="badge badge-danger">Late Approval 2</span>
          }
          {this.props.report.getIsApproveThreeDueNow() &&
          <span className="badge badge-warning">Approve 3 Now</span>
          }
          {this.props.report.getIsApproveThreeIsLate() &&
          <span className="badge badge-danger">Late Approval 3</span>
          }
          {this.props.report.getIsApproveFourDueNow() &&
          <span className="badge badge-warning">Approve 4 Now</span>
          }
          {this.props.report.getIsApproveFiveDueNow() &&
          <span className="badge badge-warning">Approve 5 Now</span>
          }
          {this.props.report.getIsApproveFourIsLate() &&
          <span className="badge badge-danger">Late Approval 4</span>
          }
          {this.props.report.getIsApproveFiveIsLate() &&
          <span className="badge badge-danger">Late Approval 5</span>
          }
          {this.props.report.getIsCompleted() &&
          <span className="badge badge-success">Complete</span>
          }
        </td>
        <td></td>
        <td>
          {this.props.report.author &&
          this.props.report.getFullNameFor('author')
          }
        </td>
        <td className="td-actions">
          <ReactTooltip place="top" className="customTheme" effect="solid"/>

          {this.props.report.getCanAcknowledge(this.props.userContext.scope) &&
          <button
            className="button default small"
            data-tip="Acknowledge"
            onClick={() => this.props.onViewReport(this.props.report.guid)}
            >
              <i className="fa fa-thumbs-up" />
            </button>
          }
          {this.props.report.getCanApprove(this.props.userContext.scope) &&
            <button
              className="button success small"
              data-tip="Approve"
              onClick={() => this.props.onViewReport(this.props.report.guid)}
            >
              <i className="fa fa-check" />
            </button>
          }
          {this.props.report.getCanApproveTwo(this.props.userContext.scope) &&
            <button
              data-tip="Approve"
              className="button success small"
              onClick={() => this.props.onViewReport(this.props.report.guid)}
            >
              <i className="fa fa-check"/>
            </button>
          }
          {this.props.report.getCanApproveThree(this.props.userContext.scope) &&
          <button
            data-tip="Approve"
            className="button success small"
            onClick={() => this.props.onViewReport(this.props.report.guid)}
          >
            <i className="fa fa-check"/>
          </button>
          }
          {this.props.report.getCanApproveFour(this.props.userContext.scope) &&
          <button
            data-tip="Approve"
            className="button success small"
            onClick={() => this.props.onViewReport(this.props.report.guid)}
          >
            <i className="fa fa-check"/>
          </button>
          }
          {this.props.report.getCanApproveFive(this.props.userContext.scope) &&
          <button
            data-tip="Approve"
            className="button success small"
            onClick={() => this.props.onViewReport(this.props.report.guid)}
          >
            <i className="fa fa-check"/>
          </button>
          }
          {this.canView &&
          <button
            className="button default small"
            data-tip="View"
          >
            <i className="fa fa-list"/>
          </button>
          }
          {this.canRewrite &&
          <button
            className="button default small"
            data-tip="Edit report"
            onClick={(e) => {e.stopPropagation(); this.props.onRewriteReport(this.props.report.guid)}}
          >
            <i className="fa fa-edit" />
          </button>
          }
        </td>
      </tr>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    userContext: state.common.userContext,
  };
};

export default connect(mapStateToProps, null)(ReportTableRow);
